<template>
  <ElPopover
    v-if="tooltipText"
    popper-class="ag-tooltip-cont"
    :virtual-ref="virtualRef"
    trigger="hover"
    virtual-triggering
    placement="top"
    :show-after="500"
    :fallback-placements="['bottom']"
    @hide="onTooltipHide"
  >
    <div>
      <span> {{ tooltipText }} </span>
      <span class="action-item" title="复制"> </span>
    </div>
  </ElPopover>
</template>

<script lang="ts" setup>
import { Ref } from 'vue';
import { ElPopover } from 'element-plus';

const props = defineProps<{
  virtualRef?: HTMLElement;
  tooltipText: () => Ref<string | undefined>;
}>();

const tooltipText = props.tooltipText();
function onTooltipHide() {
  tooltipText.value = undefined;
}
</script>

<style lang="scss">
.ag-tooltip-cont {
  min-width: max-content !important;
  max-width: 500px;
  width: max-content !important;
}
</style>
